/**
 * The "Compliance Certifications" section of the Certification & Compliance page
 * (`src/pages/why-ryerson/ryerson-commitment/certification-compliance/index.tsx`, its only
 * importer): six regulatory statements (conflict minerals, California supply-chain transparency,
 * Prop 65, RoHS, ITAR, the Ryerson Canada forced-labour report), each with a PDF to download.
 * Copy and PDF file names are in `./ComplianceCertificationsContent.tsx`; the two layouts are
 * pinned by `src/unit-test/WhyRyerson/ComplianceCertificationsDesktop.spec.tsx` and
 * `ComplianceCertificationsMobile.spec.tsx`.
 */
import React from "react";
import { Media } from "@ryerson/frontend.next";
import ComplianceCertificationsDesktop from "./ComplianceCertificationsDesktop";
import ComplianceCertificationsMobile from "./ComplianceCertificationsMobile";

/** Renders the section, mobile below `lg`. */
const ComplianceCertifications: React.FC = () => {
	return (
		<>
			<Media lessThan="lg">
				<ComplianceCertificationsMobile />
			</Media>
			<Media greaterThanOrEqual="lg">
				<ComplianceCertificationsDesktop />
			</Media>
		</>
	);
};

export default ComplianceCertifications;
